import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Drawer } from '@mui/material'
import LanguageSwitcher from './LanguageSwitcher'
import { BrandMark } from '../brand'
import { ChromeMenu, ChromeFechar } from '../brand/chrome'
import { trackMenuClick } from '../utils/analytics'

/**
 * Cabeçalho corrido (cap. 09 p.082; ADR-003; D2/D16/D25/D26).
 *  - Chapa de TINTA (D25: o chão da marca volta a ser tinta; a exibição de site do manual mostra o nav sobre tinta).
 *  - Assinatura Horizontal FIXA em 120px (D2) em todos os viewports e estados de scroll (o que encolhe é o padding).
 *  - Descritor "Da spec ao sistema. Do incidente à cura." nunca some (segunda linha em ≤ 767px, p.019).
 *  - Navegação do manual/modelo (D26): Plataforma · Planos · Casos · Contato — 4 itens, texto, sem submenu. "Sobre" vive no rodapé.
 */
const NAV = [{ to: '/platform', key: 'header.platform' }, { to: '/plans', key: 'header.plans' }, { to: '/cases', key: 'header.cases' }, { to: '/contacts', key: 'header.contacts' }]

export default function Header() {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const [compact, setCompact] = useState(false)
  const [drawer, setDrawer] = useState(false)

  useEffect(() => {
    let frame = 0
    const onScroll = () => {
      if (frame) return
      frame = requestAnimationFrame(() => { frame = 0; setCompact(window.scrollY > 50) })
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => { window.removeEventListener('scroll', onScroll); if (frame) cancelAnimationFrame(frame) }
  }, [])
  useEffect(() => { setDrawer(false) }, [pathname])

  const active = (p: string) => pathname === p || (p === '/platform' && ['/genesis', '/connect', '/auto-care'].includes(pathname))
  const go = (path: string) => () => trackMenuClick(path, 'header')
  const cls = (p: string) => ['z-header__link', active(p) && 'is-active'].filter(Boolean).join(' ')

  return (
    <header className={['z-header', compact && 'z-header--compact'].filter(Boolean).join(' ')} data-surface="dark">
      <div className="z-header__bar">
        <Link to="/" className="z-header__marca" aria-label="Zentriz — início" onClick={go('/')}>
          <BrandMark on="tinta" width={120} />
        </Link>
        <p className="z-descritor" data-anatomy="descritor">{t('brand.descriptor')}</p>

        <nav className="z-header__nav" aria-label={t('header.home')}>
          {NAV.map((n) => <Link key={n.to} to={n.to} className={cls(n.to)} onClick={go(n.to)}>{t(n.key)}</Link>)}
          <LanguageSwitcher />
        </nav>

        <button type="button" className="z-header__burger" aria-label={drawer ? 'Fechar menu' : 'Abrir menu'} aria-expanded={drawer} onClick={() => setDrawer((v) => !v)}>
          {drawer ? <ChromeFechar /> : <ChromeMenu />}
        </button>
      </div>

      <Drawer anchor="right" open={drawer} onClose={() => setDrawer(false)} slotProps={{ paper: { 'data-surface': 'dark', className: 'z-drawer' } as Record<string, string> }}>
        <nav className="z-drawer__nav" aria-label={t('header.home')}>
          <Link to="/" className="z-drawer__link" onClick={go('/')}>{t('header.home')}</Link>
          {NAV.map((n) => <Link key={n.to} to={n.to} className="z-drawer__link" onClick={go(n.to)}>{t(n.key)}</Link>)}
          <Link to="/about" className="z-drawer__link" onClick={go('/about')}>{t('header.about')}</Link>
          <div className="z-drawer__lang"><LanguageSwitcher /></div>
        </nav>
      </Drawer>
    </header>
  )
}
